





























































































import { Actor, ActorTypes } from '@/data/models/actor.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { Component, Vue, Inject, Prop } from 'vue-property-decorator';

@Component
export default class AttoreList extends Vue {
	@Inject('CrudService') crudService!: CrudService<Actor>;	
	@Prop() entityfilter!: string;
    rows: Actor[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('actor');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadCampagne() {

		const datareq = this.crudService.searchEntities(
			Actor,
			'actor',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Actor,
			'actor',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteActor(item: Actor) {
		this.$emit('delete', item);
	}

	editActor(item: Actor) {
		this.$emit('edit', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadCampagne();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadCampagne();
	}

	renewCard(row: Actor) {
		this.$emit('renewcard', row);
	}

	get isVolunteer() {
		return this.entityfilter === ActorTypes.VOLUNTEER;
	}

}
